import React, { useContext, useCallback } from 'react';
import messages from '../messages';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { getNewAllocationRule, getNewMarketplaceFilter, EDITOR_TYPE_MARKETPLACE } from '../rule-helper';
import { AllocationRulesContext } from '../context';
import { GuidService } from 'ui-components/services/guid-service';

const AddMarketplace = () => {
  const { allocationRules, allocationStrategyId, filterSets, setSavedFiltersSets, setAllocationRules, setRuleIdInEdit, marketPlaces } =
    useContext(AllocationRulesContext);

  const defaultMarketplaceId = marketPlaces.length ? marketPlaces[0].marketplaceId : undefined;

  const createMarketplaceRule = useCallback(() => {
    const orderFilterSetId = GuidService.newGuid();
    const marketplaceFilter = getNewMarketplaceFilter(defaultMarketplaceId, orderFilterSetId);
    marketplaceFilter.orderFilterSetId = orderFilterSetId;
    setSavedFiltersSets({
      ...filterSets,
      [orderFilterSetId]: marketplaceFilter,
    });
    const newMarketplaceRule = getNewAllocationRule(
      EDITOR_TYPE_MARKETPLACE,
      allocationStrategyId,
      orderFilterSetId,
      allocationRules.length + 1,
    );
    setAllocationRules([...allocationRules, newMarketplaceRule]);
    setRuleIdInEdit(newMarketplaceRule.allocationRuleId);
  }, [allocationRules, setRuleIdInEdit, setAllocationRules, filterSets, setSavedFiltersSets, allocationStrategyId, defaultMarketplaceId]);

  return (
    <DropdownMenuItem disabled={!marketPlaces.length} onClick={createMarketplaceRule}>
      <FormattedMessage {...messages.allocationStrategiesAddMarketplaceRule} />
    </DropdownMenuItem>
  );
};

export default AddMarketplace;
